export const DELETE_SUCCESS = 'Тариф удален';
export const DELETE_ERROR = 'Не удалось удалить тариф';
